import { QueryParams } from "@/models/query-params.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { BehaviorSubject, map } from "rxjs";

export class AttentionLogsService {
  private classroomId: string | undefined;

  constructor(
    private _stats = new StatsRest(),
    private _generics = new GenericsUtils()
  ) {
    this.classroomId = localStorage.getItem("stdClassroomId") ?? undefined;
  }

  attentionLogs$ = new BehaviorSubject([]);
  attentionLogs = this.attentionLogs$.asObservable();

  getAllAttentionLogsByStudent(
    courseId: string,
    studentId: string,
    params: QueryParams
  ): void {
    this._stats
      .getLogsByCourseIdAndStudentId(courseId, studentId, {
        ...params,
        classroomId: this.classroomId,
      })
      .pipe(
        map((e) => {
          e.content.forEach((item) => {
            item.convertDate = this._generics.getDate(item.date);
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.attentionLogs$.next(response);
        },
      });
  }
}
